import clsx from 'clsx';
import React from 'react';

function Panel({ children, className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div className={clsx('p-2 md:p-4 shadow-panel bg-white rounded-lg', className)} {...props}>
      {children}
    </div>
  );
}

export { Panel };
